import { render, staticRenderFns } from "./employeeAdd.vue?vue&type=template&id=1a99627a&scoped=true"
import script from "./employeeAdd.vue?vue&type=script&lang=js"
export * from "./employeeAdd.vue?vue&type=script&lang=js"
import style0 from "./employeeAdd.vue?vue&type=style&index=0&id=1a99627a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a99627a",
  null
  
)

export default component.exports